import React, { FC } from "react";

import { ErrorPage } from "./Pages/ErrorPage";
import { InsuranceLabelsContext } from "./Utils/Context/labelsContext";
import { InsuranceErrorParams } from "../../Pages/InsuranceError/InsuranceErrorParams.csharp";

export const InsuranceError: FC<InsuranceErrorParams> = (props) => {
  return (
    <InsuranceLabelsContext labels={props.insuranceLabels}>
      <ErrorPage {...props} />
    </InsuranceLabelsContext>
  );
};
